import { render, staticRenderFns } from "./RaitingTop.vue?vue&type=template&id=186df19d&scoped=true&"
import script from "./RaitingTop.vue?vue&type=script&lang=js&"
export * from "./RaitingTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186df19d",
  null
  
)

export default component.exports